import { Box, Typography, Callout, Button, Icon } from '@vp/swan';
import React, { useContext } from 'react';

import './ChatHeader.styles.scss';
import { CAContext } from '../../../contexts/CAContext';
import { isStudioPage } from '../../../utils/chat/page-utils';
import { useCustomChatEvents } from '../../../hooks/custom-hooks/useCustomChatEvents';
import { useNRLogging } from '../../../hooks/custom-hooks/useNRLogging';

export interface IChatHeaderProps {
  onChatClose?: () => void;
  onChatMinimize?: () => void;
}
const ChatHeader: React.FC<IChatHeaderProps> = ({ onChatClose, onChatMinimize }) => {
  const {
    chatState: { enableChatbot, chatHeaderText, chatSession, chatWindowHandler, chatButtonHandler },
    setChatState,
  } = useContext(CAContext);
  const { sendChatEvents } = useCustomChatEvents();
  const { logCustomAttributesNR } = useNRLogging();

  const onBackButtonClick = () => {
    /** Hide Everythinh and show help panel */

    logCustomAttributesNR('ca-chatbot-info', {
      logName: 'back_button_clicked',
      logLevel: 'info',
      message: 'User clicked on back button from chat window',
    });
    chatWindowHandler('hide');
    chatButtonHandler('hide');
    setChatState((prevState) => ({
      ...prevState,
      chatWindow: 'hidden',
    }));
    sendChatEvents('onBackButtonClicked', {});
    //TODO: Implement back button functionality
  };

  return (
    <Box className={`chatWindowHeader`} compactMode id={'chatWindowHeader'}>
      <Box className="chatMenu">
        {isStudioPage() && (
          <Button skin="tertiary" onClick={onBackButtonClick} p={4}>
            <Icon iconType="arrowLeft" size={'standard'} />
          </Button>
        )}
        <Typography fontSkin="body-standard-bold">{chatHeaderText}</Typography>
        {enableChatbot && chatSession !== 'miawChatSession' && <Callout className="callout">Beta</Callout>}
      </Box>
      <Box className="chatControls">
        <Button skin="tertiary" onClick={onChatMinimize} p={4}>
          <Icon iconType="minus" size={'standard'} />
        </Button>
        <Button skin="tertiary" onClick={onChatClose} p={4}>
          <Icon iconType="close" size={'standard'} />
        </Button>
      </Box>
    </Box>
  );
};

export default ChatHeader;
